import * as yup from "yup";

const passwordRegExp = /^(?=.{8,})(?=.*[a-z])(?=.*[A-Z])(?=.*[@#$%^&+=!]).*$/;

const LoginVS = yup.object().shape({
  email: yup
    .string()
    .required("Email is Required")
    .email("Invalid Email")
    .label("email"),
  password: yup.string().required("Password is Required").label("password"),
});

const ForgotPasswordVS = yup.object().shape({
  email: yup
    .string()
    .required("Email is Required")
    .email("Invalid Email")
    .label("email"),
});

const ResetPasswordVS = yup.object().shape({
  password: yup
    .string()
    .required("Password is Required")
    .matches(
      passwordRegExp,
      "Password must contain at least One Upper Case Character, One Lower Case Character, One Special Character and One Number"
    ),
  confirmPassword: yup
    .string()
    .required("Confirm Password is Required")
    .oneOf([yup.ref("password"), ""], "Passwords must match"),
});

const UpdatePasswordVS = yup.object().shape({
  oldPassword: yup.string().required("Current Password is Required"),
  password: yup
    .string()
    .required("New Password is Required")
    .matches(
      passwordRegExp,
      "Password must contain at least One Upper Case Character, One Lower Case Character, One Special Character and One Number"
    ),
  confirmPassword: yup
    .string()
    .required("Confirm Password is Required")
    .oneOf([yup.ref("password"), ""], "Passwords must match"),
});

const UpdateProfileVS = yup.object().shape({
  firstName: yup
    .string()
    .required("First Name  is Required")
    .label("firstName"),
  lastName: yup.string().required("Last Name  is Required").label("lastName"),
  profilePic: yup.mixed().label("profilePic"),
  phoneNumber: yup
    .string()
    .required("Phone Number is Required")
    .label("phoneNumber"),
  address: yup.string().required("Address is Required").label("address"),
});

const QuestionnaireStep1VS = yup.object().shape({
  jobs: yup.array().of(
    yup.object().shape({
      jobTitle: yup
        .string()
        .required("Job Title is Required")
        .trim("Job Title cannot include leading and trailing spaces")
        .strict(true)
        .label("Job Title")
        .min(3, "Job Title must be at least 3 characters long"),
      department: yup
        .string()
        .required("Department is Required")
        .trim("Department cannot include leading and trailing spaces")
        .strict(true)
        .label("Department"),
      jobCode: yup
        .string()
        .label("Job Code")
        .trim("Department cannot include leading and trailing spaces")
        .strict(true),
      jobGrade: yup
        .string()
        .optional()
        .label("Job Grade")
        .trim("Department cannot include leading and trailing spaces")
        .strict(true),
      roleType: yup
        .object()
        .required("Role Type is Required")
        .label("Role Type"),
    })
  ),
});

const QuestionnaireStep2VS = yup.object().shape({
  jobs: yup.array().of(
    yup.object().shape({
      jobTitle: yup.string().label("Job Title"),
      levelWork: yup
        .object()
        .required("Level of Work is Required")
        .label("Level of Work"),
      modifier: yup.object().required("Modifier is Required").label("Modifier"),
      definition: yup.string().optional().label("definition"),
      output: yup.string().optional().label("RAS Output"),
      alldropDowns: yup.array().optional().label("All Drop Downs"),
    })
  ),
});

const QuestionnaireStep3VS = yup.object().shape({
  jobs: yup.array().of(
    yup.object().shape({
      jobTitle: yup.string().label("Job Title"),
      institutionalExpertise: yup
        .object()
        .required("Institutional Expertise & Scope is Required")
        .label("Institutional Expertise & Scope"),
      definition: yup.string().optional().label("Definition"),
      output: yup.string().optional().label("RAS Output"),
    })
  ),
});

const QuestionnaireStep4VS = yup.object().shape({
  jobs: yup.array().of(
    yup.object().shape({
      jobTitle: yup.string().label("Job Title"),
      culturalImpact: yup
        .object()
        .required("Cultural Impact & Communication is Required")
        .label("Cultural Impact & Communication"),
      definition: yup.string().optional().label("Definition"),
      output: yup.string().optional().label("RAS Output"),
    })
  ),
});

const QuestionnaireStep5VS = yup.object().shape({
  jobs: yup.array().of(
    yup.object().shape({
      jobTitle: yup.string().label("Job Title"),
      physicalEnvironment: yup
        .object()
        .required("Physical Environment is Required")
        .label("Physical Environment"),
      definition: yup.string().optional().label("Definition"),
      output: yup.string().optional().label("RAS Output"),
    })
  ),
});

const QuestionnaireStep6VS = yup.object().shape({
  jobs: yup.array().of(
    yup.object().shape({
      jobTitle: yup.string().label("Job Title"),
      mentalEnvironment: yup
        .object()
        .required("Mental & Emotional Environment  is Required")
        .label("Mental & Emotional Environment "),
      definition: yup.string().optional().label("Definition"),
      output: yup.string().optional().label("RAS Output"),
    })
  ),
});

const QuestionnaireStep7VS = yup.object().shape({
  jobs: yup.array().of(
    yup.object().shape({
      jobTitle: yup.string().label("Job Title"),
      applicationLevel: yup
        .object()
        .required("Application of Knowledge & Skill is Required")
        .label("Application of Knowledge & Skill"),
      definition: yup.string().optional().label("Definition"),
      output: yup.string().optional().label("RAS Output"),
    })
  ),
});

const QuestionnaireStep8VS = yup.object().shape({
  jobs: yup.array().of(
    yup.object().shape({
      jobTitle: yup.string().label("Job Title"),
      manualEffort: yup
        .object()
        .required("Manual Effort is Required")
        .label("Manual Effort"),
      definition: yup.string().optional().label("Definition"),
      output: yup.string().optional().label("RAS Output"),
    })
  ),
});

const QuestionnaireStep9VS = yup.object().shape({
  jobs: yup.array().of(
    yup.object().shape({
      jobTitle: yup.string().label("Job Title"),
      outcomes: yup
        .object()
        .required("Outcomes  is Required")
        .label("Outcomes"),
      definition: yup.string().optional().label("Definition"),
      output: yup.string().optional().label("RAS Output"),
    })
  ),
});

const QuestionnaireStep10VS = yup.object().shape({
  jobs: yup.array().of(
    yup.object().shape({
      jobTitle: yup.string().label("Job Title"),
      notes: yup.string().optional().label("Notes"),
    })
  ),
});

const ContactVS = yup.object().shape({
  subject: yup.string().required("Subject is Required").label("Subject"),
  message: yup
    .string()
    .transform((value) => value.trim())
    .required("Message is Required")
    .label("Message")
    .max(3000, "Message can't be more than 3000 characters long"),
});

const AddOrganizationVS = yup.object().shape({
  email: yup
    .string()
    .email("Invalid Email")
    .required("Email is Required")
    .label("Email"),
  name: yup
    .string()
    .transform((value) => value.trim())
    .required("Organization Name is Required")
    .label("Organization Name")
    .min(3, "Organization Name must be at least 3 characters long"),
  address: yup
    .string()
    .transform((value) => value.trim())
    .required("Address is Required")
    .label("Address"),
  contactNo: yup
    .string()
    .required("Contact Number is Required")
    .label("Contact Number"),
  users: yup.array().of(
    yup.object().shape({
      name: yup
        .string()
        .transform((value) => value.trim())
        .required("User FullName is Required")
        .label("FullName")
        .min(3, "User FullName must be at least 3 characters long"),
      email: yup
        .string()
        .email("Invalid Email")
        .required("Email is Required")
        .label("Email"),
      role: yup
        .string()
        .transform((value) => value.trim())
        .required("Role is Required")
        .label("Role"),
    })
  ),
});

const EditQuestionVS = yup.object().shape({
  text: yup
    .string()
    .transform((value) => value.trim())
    .min(5, "Statement must be at least 5 characters long")
    .required("Statement is Required")
    .label("Statement"),
});

const EditOptionVS = yup.object().shape({
  option: yup.object().required("Option is Required"),
  role: yup.object().required("Role is Required"),
  dropdown: yup.object().required("Category is Required"),
  short_text: yup
    .string()
    .transform((value) => value.trim())
    .min(5, "Short Definition must be at least 5 characters long")
    .required("Short Definition is Required")
    .label("Short Definition"),
  long_text: yup
    .string()
    .transform((value) => value.trim())
    .min(5, "Long Definition must be at least 5 characters long")
    .required("Long Definition is Required")
    .label("Long Definition"),
});

export {
  LoginVS,
  ForgotPasswordVS,
  ResetPasswordVS,
  UpdatePasswordVS,
  UpdateProfileVS,
  QuestionnaireStep1VS,
  QuestionnaireStep2VS,
  QuestionnaireStep3VS,
  QuestionnaireStep4VS,
  QuestionnaireStep5VS,
  QuestionnaireStep6VS,
  QuestionnaireStep7VS,
  QuestionnaireStep8VS,
  QuestionnaireStep9VS,
  QuestionnaireStep10VS,
  ContactVS,
  AddOrganizationVS,
  EditQuestionVS,
  EditOptionVS,
};
